<div *ngIf="customer">
    <div class="flex justify-between items-center">
        <div class="flex-grow">
            <a class="text-lg font-bold" [href]="customerLink">
                <span class="text-lg font-bold"
                    >{{ customer?.firstName }}&nbsp;{{
                        customer?.lastName
                    }}</span
                >
            </a>
            <span class="ml-2">
                {{ customer.gender ? (customer.gender | titlecase) : '' }} |
                DOB:
                {{ customer.dob ? (customer.dob | date) : '-' }}
                {{ customer.dob ? '(' + (customer.dob | age) + ' yrs)' : '' }}
            </span>
        </div>
        <div class="flex items-center justify-between gap-2">
            <button
                nz-button
                nzType="dashed"
                nzShape="circle"
                nzSize="small"
                (click)="openIdImages('govId')"
                [nz-tooltip]="
                    IDVerificationStatus === 'verified'
                        ? 'View Documents — ID Verified by ' +
                          IDVerifiedBy +
                          (expiryDateDisplay
                              ? ' (Expires: ' + expiryDateDisplay + ')'
                              : '')
                        : IDVerificationStatus === 'manual-check-required'
                        ? 'View Documents — Requires Manual Check'
                        : 'View Documents — ID Not Verified'
                "
                [class]="
                    IDVerificationStatus === 'verified'
                        ? IDVerifiedBy === 'Persona'
                            ? 'fill-green'
                            : 'fill-blue'
                        : IDVerificationStatus === 'manual-check-required'
                        ? 'fill-orange'
                        : 'not-fill'
                "
            >
                <i class="fa-solid fa-id-card"></i>
            </button>
            <button
                nz-button
                nzType="dashed"
                nzShape="circle"
                nzSize="small"
                (click)="openIdImages('drugCard')"
                [nz-tooltip]="
                    isInsuranceAvailable || hasDrugCardCoverage
                        ? 'View drug cards — Coverage on file'
                        : 'View drug cards — No coverage on file'
                "
                class="flex items-center justify-center p-0"
                [class.fill-blue]="isInsuranceAvailable || hasDrugCardCoverage"
            >
                <i class="fa-solid fa-shield-heart"></i>
            </button>
            <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="openCreateRx()"
            >
                Write RX
            </button>
            <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="openActivity()"
            >
                Activity
            </button>
            <button
                nz-button
                nzSize="small"
                nzType="primary"
                (click)="openChat()"
            >
                Chat
            </button>
        </div>
    </div>

    <nz-descriptions
        class="mt-2"
        [nzColumn]="{
            xxl: 4,
            xl: 4,
            lg: 3,
            md: 2,
            sm: 2,
            xs: 1
        }"
    >
        <nz-descriptions-item nzTitle="Email">
            <span> {{ customer?.email }}</span>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Phone">
            <span>{{ customer?.phone }}</span>
        </nz-descriptions-item>
        <nz-descriptions-item nzTitle="Address">
            <portals-emr-address-display [address]="customer?.defaultAddress" />
        </nz-descriptions-item>
    </nz-descriptions>
    <div class="flex gap-2 mt-2">
        <span
            >Allergies:
            <nz-tag *ngFor="let allergy of allergies">{{ allergy }}</nz-tag>
            <nz-tag *ngIf="allergies?.length === 0">None</nz-tag>
        </span>
        <span
            >Medications:
            <nz-tag *ngFor="let medication of medications">{{
                medication
            }}</nz-tag>
            <nz-tag *ngIf="medications?.length === 0">None</nz-tag>
        </span>
        <span
            >Conditions:
            <nz-tag *ngFor="let condition of conditions">{{
                condition
            }}</nz-tag>
            <nz-tag *ngIf="conditions?.length === 0">None</nz-tag>
        </span>
    </div>
</div>
<nz-spin *ngIf="!customer"></nz-spin>

<portals-emr-customer-documents-modal
    [customer]="customer"
    (verificationChanged)="verificationChanged.emit()"
></portals-emr-customer-documents-modal>
